import { render } from "./StorePurchaseRequisition.vue?vue&type=template&id=60e441d7&scoped=true"
import script from "./StorePurchaseRequisition.vue?vue&type=script&lang=js"
export * from "./StorePurchaseRequisition.vue?vue&type=script&lang=js"

import "./StorePurchaseRequisition.vue?vue&type=style&index=0&id=60e441d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e441d7"]])

export default __exports__